import PostLink from './post-link'

export default PostLink



// WEBPACK FOOTER //
// ./src/scenes/feed/post-link/index.js